import { Divider } from 'primereact/divider';
import cn from 'classnames';

import classes from './footer.module.scss'

export const PasswordFieldFooter = (
  <div className={classes.root}>
    <Divider />
    <p className="p-mt-2">Recommendation</p>
    <ul className={cn("p-pl-2 p-ml-2 p-mt-0", classes.list)}>
      <li>At least one lowercase</li>
      <li>At least one uppercase</li>
      <li>At least one numeric</li>
      <li>At least one symbol ~!@#$%^&*()-_=+[]{}|</li>
      <li>Minimum 14 characters</li>
    </ul>
  </div>
);
